import { defineMessages } from 'react-intl';

export default defineMessages({
    searchAddress: {
        id: 'ml.youraddress.placeholder.Type here to search for address (No PO Box)',
        defaultMessage: 'Type here to search for address (No PO Box)',
    },
    searchAddressAgain: {
        id: 'ml.youraddress.placeholder.Type address here to search again',
        defaultMessage: 'Type address here to search again',
    },
    selectAddressFromList: {
        id: 'ml.youraddress.list.Select an address from the list or choose My address is not in this list',
        defaultMessage: 'Select an address from the list or choose My address is not in this list'
    },
    addressNotInListMessage: {
        id: 'ml.youraddress.list.My address is not in this list.',
        defaultMessage: 'My address is not in this list.'
    },
    addressAlertAnnouncement: {
        id: 'ml.youraddress.list.Editing address, Please input the address manually.',
        defaultMessage: 'Editing address, Please input the address manually.'
    },
    manualAddressLabel: {
        id: 'ml.youraddress.manualAddress.Enter your address below',
        defaultMessage: 'Enter your address below'
    },
    addressPopulatedLabel: {
        id: 'ml.youraddress.addressPopulated.Address populated below',
        defaultMessage: 'Address populated below'
    },
    addressLine1Placeholder: {
        id: 'ml.youraddress.addressdetails.Enter your address (No PO Box)',
        defaultMessage: 'Enter your address (No PO Box)'
    },
    addressLine2Placeholder: {
        id: 'ml.youraddress.addressdetails.Apt/Unit #',
        defaultMessage: 'Apt/Unit #'
    },
    enterCurrentAddress: {
        id: 'ml.youraddress.addressDetails.Enter your current address here',
        defaultMessage: 'Enter your current address here'
    },
    editAddress: {
        id: 'ml.youraddress.addressDetails.Edit Address',
        defaultMessage: 'Edit Address'
    },
    mailingAddressPOBox: {
        id: 'ml.youraddress.addressDetails.Mailing Address is a PO BOX',
        defaultMessage: 'Mailing Address is a PO BOX'
    },
    continueTypingForMoreResults: {
        id: 'ml.youraddress.addressDetails.Continue typing for more results...',
        defaultMessage: 'Continue typing for more results...'
    }
});